module.exports = __webpack_public_path__ + "/img/MELF-a5NOhU.svg";